import { render, staticRenderFns } from "./WeekItem.vue?vue&type=template&id=d2ba806e&"
import script from "./WeekItem.vue?vue&type=script&lang=js&"
export * from "./WeekItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports